import React from 'react';
import { Result, Button } from 'antd';
import { useLocation } from "react-router-dom";

export default function ErrorPage(props: any) {
	const { search } = useLocation();

	function onLogin() {
		const searchParams = new URLSearchParams(search);

		window.location.href = decodeURIComponent(searchParams.get('workspaceURL') as string);
	}

	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
			<Result
				status="error"
				title="This workspace is deactivated or non-existent"
				subTitle={
					<>
            This workspace is deactivated or non-existent. Please contact
						<a href="mailto:support@splashtop.com">
							&nbsp;support@splashtop.com
						</a> for assistance.
					</>
				}
				extra={[
					<div key="1">
						<p>Want to sign into a different workspace?</p>
						<Button style={{ width: '240px' }} key="1" type="primary" onClick={onLogin} size="large" block>Change Your workspace</Button>
					</div>,
				]}
			/>
		</div>
	);
}

